import { Stack } from 'expo-router';

export default function ProductFlowLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
